module.exports = __webpack_public_path__ + "static/media/sdg.6a4a77f1.png";